import { post } from "@/api/index"; // AxiosInstance

export const getPostInfo: (params: any) => Promise<any> = (params: any) => {
  return post("/post/getreplylist",params);
};

export const isCode: (params: any) => Promise<any> = (params: any) => {
  return post("/verify/isCode",params);
};

export const pub_reply: (params: any) => Promise<any> = (params: any) => {
  return post("/post/pub_reply?act=pub&_json=1",params);
};

export const commentadd: (params: any) => Promise<any> = (params: any) => {
  return post("/comment/add",params);
};

export const commentindex: (params: any) => Promise<any> = (params: any) => {
  return post("/comment/index",params);
};

export const delreply: (params: any) => Promise<any> = (params: any) => {
  return post("/post/delreply",params);
};

export const delcomment: (params: any) => Promise<any> = (params: any) => {
  return post("/comment/del",params);
};

export const commentfavorites: (params: any) => Promise<any> = (params: any) => {
  return post("/post/commentfavorites",params);
};

export const add_reply_favorites: (params: any) => Promise<any> = (params: any) => {
  return post("/post/add_reply_favorites",params);
};

export const followuser: (params: any) => Promise<any> = (params: any) => {
  return post("/home/followuser", params);
};

